
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import DialogSeletedStaff from "../staff/components/setStaff.vue";
import { getUserList, setUser } from "@/api/project";
import { getCompanySet, modifyCompanySet } from "@/api/system";
import { getUserInfo } from "@/api/users";

@Component({
  name: "ProjectSetting",
  components: {
    DialogSeletedStaff,
  },
})
export default class extends Vue {
  private dialogSetStaffVisible = false;
  private enterType = 13;
  private isRadio = false;
  private activeName = "settingStaff";
  private pamrasSet = {
    project_alias: "项目",
    project_task_collect_alias: "任务集",
    project_task_alias: "任务",
  };
  private windowHg = window.innerHeight - 95;
  private isInSetting = [false, false, false];
  private projectAlias = UserModule.getCompany.project_alias
    ? UserModule.getCompany.project_alias
    : "项目";

  private isTaskset = true;

  created() {
    this.getUserList();
    this.getCompanySet();
  }

  private getUserList() {
    this.selectSuperArray = [];
    this.selectLookArray = [];
    this.selectSetArray = [];
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.user_name = UserModule.getUserName;
    params.company_name = UserModule.getCompanyName;
    getUserList(params).then((res: any) => {
      if (res.data.super_admin_user_list) {
        res.data.super_admin_user_list.forEach((element: any) => {
          if (element.user_id === UserModule.getUserId) {
            this.isInSetting[0] = true;
          }
          let u: any = {};
          u.id = element.user_id;
          u.name = element.user_name;
          u.mobile = element.mobile;
          this.selectSuperArray.push(u);
        });
      }
      if (res.data.look_up_user_list) {
        res.data.look_up_user_list.forEach((element: any) => {
          if (element.user_id === UserModule.getUserId) {
            this.isInSetting[1] = true;
          }
          let u: any = {};
          u.id = element.user_id;
          u.name = element.user_name;
          u.mobile = element.mobile;
          this.selectLookArray.push(u);
        });
      }
      if (res.data.init_project_user_list) {
        res.data.init_project_user_list.forEach((element: any) => {
          if (element.user_id === UserModule.getUserId) {
            this.isInSetting[2] = true;
          }
          let u: any = {};
          u.id = element.user_id;
          u.name = element.user_name;
          u.mobile = element.mobile;
          this.selectSetArray.push(u);
        });
      }
    });
  }
  private getCompanySet() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.vip_level = (UserModule.company as any).vip_level;
    getCompanySet(params)
      .then((res) => {
        if (res.data && res.data.companySet) {
          if (res.data.companySet.project_alias) {
            this.pamrasSet.project_alias = res.data.companySet.project_alias;
          }
          if (res.data.companySet.project_task_collect_alias) {
            this.pamrasSet.project_task_collect_alias =
              res.data.companySet.project_task_collect_alias;
          }
          if (res.data.companySet.project_task_alias) {
            this.pamrasSet.project_task_alias =
              res.data.companySet.project_task_alias;
          }
          this.isTaskset = parseInt(res.data.companySet.is_open_project_task_collect) === 1;
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }
  private save() {
    let params: any = {};
    params.project_alias = this.pamrasSet.project_alias;
    params.project_task_collect_alias =
      this.pamrasSet.project_task_collect_alias;
    params.project_task_alias = this.pamrasSet.project_task_alias;
    //修改为单独保存
    // params.is_open_project_task_collect = this.isTaskset ? '1' : '0';
    this.modifyCompanySet(params);
  }

  private saveOpenProjectTaskCollect() {
    let params: any = {};
    params.is_open_project_task_collect = this.isTaskset ? '1' : '0';
    this.modifyCompanySet(params);
  }

  private modifyCompanySet(pamars: any) {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      ...pamars,
    };
    modifyCompanySet(params)
      .then(async(res) => {
        this.showSuccessMsg((res as any).msg);
        let parameters: any = {};
        parameters.user_id = UserModule.getUserId;
        parameters.company_id = UserModule.getCompanyId;
        await getUserInfo(parameters).then(async(res) => {
          await UserModule.setLogin(res.data);
        });
        this.getCompanySet();
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private closeSeleted() {
    this.dialogSetStaffVisible = false;
  }
  private superHandle() {
    this.isRadio = true;
    this.enterType = 13;
    this.selectArray = this.selectSuperArray;
    this.dialogSetStaffVisible = true;
  }
  private superStaff(val: any) {
    this.setUser(10, [val]);
  }

  private lookHandle() {
    this.isRadio = false;
    this.enterType = 14;
    this.dialogSetStaffVisible = true;
    this.selectArray = this.selectLookArray;
  }
  private setHandle() {
    this.enterType = 15;
    this.isRadio = false;
    this.dialogSetStaffVisible = true;
    this.selectArray = this.selectSetArray;
  }
  private selectedStaff(val: any) {
    switch (this.enterType) {
      case 13:
        this.setUser(10, val);
        break;
      case 14:
        this.setUser(20, val);
        break;
      case 15:
        this.setUser(30, val);
        break;
    }
  }
  private selectSuperArray: any = [];
  private selectLookArray: any = [];
  private selectSetArray: any = [];
  private selectArray: any = [];
  private setUser(type: number, selectArray: any) {
    let arr: any = [];
    selectArray.forEach((user: any) => {
      let u: any = {};
      u.id = user.id;
      u.name = user.name;
      u.mobile = user.mobile;
      arr.push(u);
    });
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.user_name = UserModule.getUserName;
    params.company_name = UserModule.getCompanyName;
    params.type = type;
    params.user_list = JSON.stringify(arr);
    setUser(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.dialogSetStaffVisible = false;
        this.reload(type, arr);
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private reload(type: number, arrList: any) {
    let needLoad = false;
    arrList.forEach((element: any) => {
      switch (type) {
        case 10:
          if (
            (this.isInSetting[0] && element.id === UserModule.getUserId) ||
            (!this.isInSetting[0] && element.id !== UserModule.getUserId)
          ) {
            needLoad = false;
          } else {
            needLoad = true;
          }
          break;
        case 20:
          if (
            (this.isInSetting[1] && element.id === UserModule.getUserId) ||
            (!this.isInSetting[1] && element.id !== UserModule.getUserId)
          ) {
            needLoad = false;
          } else {
            needLoad = true;
          }
          break;
        case 30:
          if (
            (this.isInSetting[2] && element.id === UserModule.getUserId) ||
            (!this.isInSetting[2] && element.id !== UserModule.getUserId)
          ) {
            needLoad = false;
          } else {
            needLoad = true;
          }
          break;
      }
    });
    if (needLoad) {
      this.getUserList();
      window.location.reload();
    } else {
      this.getUserList();
    }
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
